'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.filterFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/filterFromIndex.js
// module id = 371
// module chunks = 0